export default __webpack_public_path__ + "static/media/a12.2b418b3a.jpg";